import { Field } from "react-final-form";
import { FileDropzone } from "@/shared/components/FileDropzone";
import {
  UploadFileMutation,
  UploadPrivateFileMutation,
  FileQuery,
  PrivateFileQuery,
} from "@/shared/graphql";

export type FileFieldType = "file" | "privateFile";

interface FileFieldProps {
  name: string;
  fileType: FileFieldType;
  label: string;
  helperText?: string;
  required?: boolean;
  accept?: string;
  maxSize?: number;
  deleteFileText?: string;
  fileUploadedText?: string;
  fileDeletedText?: string;
  downloadText?: string;
}

const FILE_CONFIG = {
  file: {
    mutation: UploadFileMutation,
    query: FileQuery,
    accept: "*",
  },
  privateFile: {
    mutation: UploadPrivateFileMutation,
    query: PrivateFileQuery,
    accept: "*",
  },
};

export function FileField({
  name,
  fileType,
  label,
  helperText,
  required = false,
  accept,
  maxSize,
  deleteFileText,
  fileUploadedText,
  fileDeletedText,
  downloadText,
  ...restProps
}: FileFieldProps) {
  const config = FILE_CONFIG[fileType];

  return (
    <Field
      name={name}
      render={({ input: { onChange, value }, ...rest }) => (
        <FileDropzone
          onChange={onChange}
          value={value}
          query={config.query}
          mutation={config.mutation}
          label={label}
          helperText={helperText}
          required={required}
          accept={accept ?? config.accept}
          maxSize={maxSize}
          deleteFileText={deleteFileText}
          fileUploadedText={fileUploadedText}
          fileDeletedText={fileDeletedText}
          downloadText={downloadText}
          {...rest}
          {...restProps}
        />
      )}
    />
  );
}
